import React from "react";
import { ActionTypes } from "../../action-type";
import secureLocalStorage from "react-secure-storage";
import axiosInstance from "../../../services/axios";


export const createVote = (values)=>async(dispatch)=>{
    try{
        const response = await axiosInstance.post("/voting/",values);
        const {data} = response;
        dispatch({
            type:ActionTypes.VOTING,
            payload:data
        })
    }
    catch (err){
        console.log(err,"error from action")
        // throw(err)
    }
}

export const updateVote = (values)=>async(dispatch)=>{
    try{
        const response = await axiosInstance.put("/voting/",values);
        const {data} = response;
        dispatch({
            type:ActionTypes.VOTING,
            payload:data
        })
    }
    catch(err){
        throw(err)
    }
}
export const getVotes = (values)=>async(dispatch)=>{
    console.log(values,"from action")
    try{
        const response = await axiosInstance.get(`/votingteam/votes`,{params:values});
        const {data} = response;
        console.log(response,"====")
        dispatch({
            type:ActionTypes.VOTING,
            payload:data
        })
    }
    catch(err){
        throw(err)
    }
}